import React, { useState, useEffect } from 'react';
import '../css/hero.css';

const HERO_CARDS = [

{
  tag: 'Beyond the Innovation: Hamid Kohan',
  title:
    'AI Virtual: How Founder Hamid Kohan Is Transforming Business Productivity Through Artificial Intelligence',
  href: '/magazine/AI_Virtual',
},
{
  tag: 'AI Automation & Business Impact',
  title:
    'Hamid Kohan: The Founder of AI Virtual Driving Smarter Business Operations',
  href: '/article/AI_Virtual',
},

  { tag: 'Global Business Leaders', title: 'Reinventing Success with Revolutionary Leadership', href: '/magazine' },
];

const MAGAZINE_COVERS = [
  {
    photo: 'https://xenogeneic-turquoise-isfetp2h.edgeone.dev/Hamid%20kohan%20cover.jpg', // add a cover-photo URL/import here when available
    href: '/magazine/AI_Virtual', // update with the real magazine/article URL for this cover
  },
  {
    photo: 'https://architectural-amber-bycffsc3.edgeone.dev/Cover%20Page.png',
    href: '/magazine/Jennifer_White', // update with the real magazine/article URL for this cover
  },
  {
    photo: 'https://clear-amethyst-lxbilkmj.edgeone.dev/file.png', // add a cover-photo URL/import here when available
    href: '/magazine/Dana_Hatch', // update with the real magazine/article URL for this cover
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs1.png', // add a cover-photo URL/import here when available
    href: '/magazine/1',
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs2.png',
    href: '/magazine/2',
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs3.png',
    href: '/magazine/3',
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs4.png',
    href: '/magazine/4',
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs5.png',
    href: '/magazine/5',
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs6.png',
    href: '/magazine/6',
  },
  {
    photo: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs7.png',
    href: '/magazine/7',
  }
];

/* Replace with real logo image imports/paths when available */
const BRAND_LOGOS = [
  { name: 'Apple', label: 'Apple', logo: 'https://careful-silver-5z33wory.edgeone.dev/apple-logo.png' },
  { name: 'Microsoft', label: 'Microsoft', logo: 'https://careful-silver-5z33wory.edgeone.dev/microsoft.png' },
  { name: 'Google', label: 'Google', logo: 'https://careful-silver-5z33wory.edgeone.dev/Google.png' },
  { name: 'Amazon', label: 'Amazon', logo: 'https://careful-silver-5z33wory.edgeone.dev/Amazon.png' },
  { name: 'NVIDIA', label: 'NVIDIA', logo: 'https://careful-silver-5z33wory.edgeone.dev/nvidia.png' },
  { name: 'Tesla', label: 'Tesla', logo: 'https://careful-silver-5z33wory.edgeone.dev/Tesla.png' },
  { name: 'IBM', label: 'IBM', logo: 'https://careful-silver-5z33wory.edgeone.dev/ibm.png' },
  { name: 'Oracle', label: 'Oracle', logo: 'https://careful-silver-5z33wory.edgeone.dev/oracle.png' },
  { name: 'Adobe', label: 'Adobe', logo: 'https://careful-silver-5z33wory.edgeone.dev/adobe.png' },
  { name: 'Salesforce', label: 'Salesforce', logo: 'https://careful-silver-5z33wory.edgeone.dev/Salesforce.png' },
  // { name: 'Social',        label: 'Social', logo: 'https://purring-chocolate-q2jyrqxk.edgeone.dev/social.png' },
  // { name: 'Search',        label: 'Search', logo: 'https://purring-chocolate-q2jyrqxk.edgeone.dev/search.png' },
  { name: 'Deloitte', label: 'Deloitte', logo: 'https://careful-silver-5z33wory.edgeone.dev/Deloitte.png' },
  { name: 'PwC', label: 'PwC', logo: 'https://careful-silver-5z33wory.edgeone.dev/PwC.png' },
  { name: 'EY', label: 'EY', logo: 'https://careful-silver-5z33wory.edgeone.dev/EY.png' },
  { name: 'KPMG', label: 'KPMG', logo: 'https://careful-silver-5z33wory.edgeone.dev/KPMG.png' },
  { name: 'Accenture', label: 'Accenture', logo: 'https://careful-silver-5z33wory.edgeone.dev/Accenture.png' },
  { name: 'Cisco', label: 'Cisco', logo: 'https://careful-silver-5z33wory.edgeone.dev/Cisco.png' },
  { name: 'SAP', label: 'SAP', logo: 'https://careful-silver-5z33wory.edgeone.dev/SAP.png' },
  { name: 'Siemens', label: 'Siemens', logo: 'https://careful-silver-5z33wory.edgeone.dev/Siemens.png' },
  { name: 'Ferrari', label: 'Ferrari', logo: 'https://careful-silver-5z33wory.edgeone.dev/Ferrari.png' },
  { name: 'Lamborghini', label: 'Lamborghini', logo: 'https://careful-silver-5z33wory.edgeone.dev/Lamborghini.png' },
  { name: 'Porsche', label: 'Porsche', logo: 'https://careful-silver-5z33wory.edgeone.dev/Porsche.png' },
  { name: 'Rolex', label: 'Rolex', logo: 'https://careful-silver-5z33wory.edgeone.dev/Rolex.png' },
  { name: 'Louis Vuitton', label: 'Louis Vuitton', logo: 'https://careful-silver-5z33wory.edgeone.dev/Louis%20Vuitton.png' },
  { name: 'Dior', label: 'Dior', logo: 'https://careful-silver-5z33wory.edgeone.dev/Dior.png' },
  { name: 'Chanel', label: 'Chanel', logo: 'https://careful-silver-5z33wory.edgeone.dev/Chanel.png' },
  { name: 'Hermès', label: 'Hermès', logo: 'https://careful-silver-5z33wory.edgeone.dev/Hermès.png' },
  { name: 'Gucci', label: 'Gucci', logo: 'https://careful-silver-5z33wory.edgeone.dev/Gucci.png' },
  { name: 'Prada', label: 'Prada', logo: 'https://careful-silver-5z33wory.edgeone.dev/Prada.png' },
];

export default function Hero() {
  const [active, setActive] = useState(Math.floor(MAGAZINE_COVERS.length / 2));

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((i) => (i + 1) % MAGAZINE_COVERS.length);
    }, 2000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="hero" aria-label="Hero">
      <div className="hero-grid-bg" aria-hidden="true" />
      <div className="hero-radial" aria-hidden="true" />

      <div className="hero-wrap">
        {/* ── Left column — magazine cover fan ── */}
        <div className="hero-left">
          <div className="mag-fan" aria-label="Featured magazine covers">
            {MAGAZINE_COVERS.map((cover, i) => {
              const offset = i - active;
              const isActive = offset === 0;
              return (
                <div
                  key={cover.name ?? i}
                  className={`mag-card ${isActive ? 'is-active' : ''}`}
                  style={{
                    '--offset': offset,
                    zIndex: 100 - Math.abs(offset),
                  }}
                  aria-hidden={!isActive}
                >
                  <div className="mag-card-inner">
                    <a
                      className="mag-photo"
                      href={cover.href || '/magazine'}
                      tabIndex={isActive ? 0 : -1}
                      aria-label={cover.name ? `Open ${cover.name} magazine` : 'Open magazine'}
                    >
                      {cover.photo ? (
                        <img src={cover.photo} alt={cover.name || 'Magazine cover'} />
                      ) : (
                        <div className="mag-photo-placeholder" aria-hidden="true" />
                      )}
                    </a>

                    <div className="mag-overlay">
                      <p className="mag-masthead">
                        {/* The <span>Elite Global</span> Review */}
                      </p>
                      <p className="mag-issue">{cover.issue}</p>

                      <div className="mag-headline-block">
                        <span className="mag-kicker">{cover.kicker}</span>
                        <p className="mag-headline">{cover.headline}</p>
                      </div>

                      {/* <div className="mag-byline">
                        <p className="mag-name">{cover.name}</p>
                        {cover.surname && <p className="mag-surname">{cover.surname}</p>}
                        <p className="mag-tagline">{cover.tagline}</p>
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <a href="/magazine" className="mag-cta">Read All Magazines</a>
        </div>

        {/* ── Right column — feature cards ── */}
        <div className="hero-right">
          <div className="hero-card-list" role="list">
            {HERO_CARDS.map((card, i) => (
              <a
                key={i}
                className="hcard"
                href={card.href}
                style={{ '--i': i }}
                role="listitem"
              >
                <span className="hcard-tag">{card.tag}</span>
                <h3>{card.title}</h3>
                <span className="hcard-arrow" aria-hidden="true">&#8594;</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Trusted brands marquee (right → left) */}
      <div className="brand-marquee" aria-label="Trusted brands">
        <p className="brand-marquee-label"> Trusted Brands Featured by The Elite Global Review</p>

        <div className="brand-track">
          <div className="brand-track-inner">
            {[...BRAND_LOGOS, ...BRAND_LOGOS].map((brand, i) => (
              <div className="brand-logo" key={`${brand.name}-${i}`}>
                {brand.logo ? (
                  <img src={brand.logo} alt={brand.name} loading="lazy" />
                ) : (
                  <span>{brand.label}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}